import type {
  BindingSource,
  ConsolidatedBindingContext,
} from '@packages/systems/dynamo/gateway';

import {hasAllowedType} from './ParamPanelUtils';

// TODO: The data structure used by the conditional visibility binding target
//       to store conditions doesn't support binding paths with depth > 2.
//       Remove this arbitrary cap on binding source path length after we have
//       refactored conditional visibility support deep binding paths.
const hasDeepBindingPath = (source: BindingSource) => source.path.length > 2;

// TODO: Conditional visibility binding target excludes nested ItemRef and
//       ItemRefSet field from field options.
//       Investigate if this restriction can be lifted.
const isNestedReference = (source: BindingSource) =>
  source.parentId != null &&
  (source.type === 'ItemRef' || source.type === 'ItemRefSet');

function isAllowed(bindingSource: BindingSource) {
  return (
    hasAllowedType(bindingSource) &&
    !hasDeepBindingPath(bindingSource) &&
    !isNestedReference(bindingSource)
  );
}

export function getConditionalVisibilityBindingSources(
  bindingContext: ConsolidatedBindingContext
): BindingSource[] {
  const bindingSources = bindingContext.getExpandedBindingSources();
  return bindingSources.filter(isAllowed);
}
